import Link from 'next/link';
import { IDENTIFIERS, getUrl } from '@/helpers/urlsHelper';

type Props = {
  currentTeamOwner: {
    person: { id: string };
  } | null;
  person: {
    name: string | null;
    id: string | null;
  }
};

const TakenByColumn: React.FC<Props> = ({ currentTeamOwner, person }) => {
  if (currentTeamOwner?.person.id === person.id) {
    return (
      <p className="caption">{person.name}</p>
    );
  }
  return (
    <Link href={getUrl(IDENTIFIERS.DASHBOARD_MEMBER, { id: person.id || '' })} className="caption" target="_blank">
      {person.name}
    </Link>
  );
};

export default TakenByColumn;
